module.exports = __webpack_public_path__ + "static/media/Logo.a9a00281.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Logo.svg
// module id = 312
// module chunks = 0